import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const PrivateRoute = () => {
  const { jwtToken } = useContext(AuthContext);

  if (!jwtToken) {
    return <Navigate to="/login" />;
  }

  // If the user is authenticated and not a manager, allow access to the requested route
  return <Outlet />;
};

export default PrivateRoute;
